<template>
<div>
  <div class="rich-input">
    <input class="rich-input-field"
      :placeholder="placeholder"
      :value="inputValue"
      :maxlength="maxlength"
      type="text"
      @input="changeHandle($event.target)">
  </div>
</div>
</template>
<script>
export default {
  name: 'PostCode',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String
    },
    maxlength: {
      type: Number
    }
  },
  data () {
    return {
      inputValue: this.value
    }
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    changeHandle (target) {
      let value = target.value.trim().replace(/[^0-9\.\-\/]/g, '')
      let numberStr = value.replace(/\.|\-|\//g, '')
      let newStr = value
      if (value.length >= this.inputValue.length) {
        newStr = this.format(numberStr)
      }
      target.value = newStr
      this.inputValue = newStr
      this.$emit('input', this.inputValue)
    },
    format (str) {
      return str.replace(/^(\d{3})(\d{0,4})$/, (matchStr, first, second) => {
        let newStr = ''
        newStr = first
        if (second) {
          newStr = newStr + '-' + second
        }
        return newStr
      })
    }
  }
}
</script>
<style lang="stylus" scoped>

</style>